// Leichter Toast-Store ohne Dependency — Publisher/Subscriber + Auto-Dismiss.
import { ApiError } from '../api/client'

export interface ToastItem {
  id: number
  kind: 'error' | 'success'
  message: string
}

let nextId = 1
let items: ToastItem[] = []
const subscribers = new Set<(items: ToastItem[]) => void>()

function emit(): void {
  for (const cb of subscribers) cb(items)
}

function push(kind: ToastItem['kind'], message: string, autoDismissMs = 6000): number {
  const id = nextId++
  items = [...items, { id, kind, message }]
  emit()
  if (autoDismissMs > 0) setTimeout(() => toast.dismiss(id), autoDismissMs)
  return id
}

export const toast = {
  error: (message: string) => push('error', message),
  success: (message: string) => push('success', message, 3000),
  dismiss: (id: number) => {
    items = items.filter((t) => t.id !== id)
    emit()
  },
}

export function subscribeToasts(cb: (items: ToastItem[]) => void): () => void {
  subscribers.add(cb)
  cb(items)
  return () => {
    subscribers.delete(cb)
  }
}

export function formatMutationError(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.status === 423) return 'Demo-Modus: Aktion gesperrt (423) — Amazon-Writes sind deaktiviert.'
    if (error.status === 403) return 'Keine Berechtigung (403) — Admin-Rechte erforderlich.'
    return `Aktion fehlgeschlagen (${error.status}): ${error.message}`
  }
  return `Aktion fehlgeschlagen: ${error instanceof Error ? error.message : String(error)}`
}
